import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { Card, CardContent, CardFooter, CardHeader } from '@achra/ui/card';
import { cn } from '@achra/ui/lib/utils';
import { Separator } from '@achra/ui/separator';
import { ArrowRight } from 'lucide-react';
import Link from 'next/link';
import type { ExpenseReport_ExpenseReportStatus } from '@/modules/__generated__/graphql/switchboard-generated';
import { LastModified } from '@/modules/builders/components/builders/components/last-modified';
import { formatReportingMonth, getAmountByMetric, getMetricLabel } from '@/modules/finances/lib/budget-statement-utils';
import type { BudgetStatement, MetricWithoutBudget } from '@/modules/finances/types';
import { usLocalizedNumber } from '@/modules/shared/lib/humanization';
import { slugify } from '@/modules/shared/lib/slug';
import { BudgetStatementsStatus } from '../budget-statements-status/budget-statements-status';
import { ContributorProfileInfo } from '../contributor-profile-info/contributor-profile-info';
import { LabeledValue } from '../labeled-value';
export interface BudgetStatementMobileItemProps {
  budgetStatement: BudgetStatement;
  selectedMetric: MetricWithoutBudget;
}
function BudgetStatementMobileItem(t0) {
  const $ = _c(68);
  const {
    budgetStatement,
    selectedMetric
  } = t0;
  let T0;
  let T1;
  let T2;
  let T3;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== budgetStatement || $[1] !== selectedMetric) {
    const reportMonth = formatReportingMonth(budgetStatement.month);
    const amount = getAmountByMetric(selectedMetric, budgetStatement);
    let t10;
    if ($[15] !== selectedMetric) {
      t10 = getMetricLabel(selectedMetric);
      $[15] = selectedMetric;
      $[16] = t10;
    } else {
      t10 = $[16];
    }
    const metricLabel = t10;
    let t11;
    if ($[17] !== budgetStatement.owner.name) {
      t11 = slugify(budgetStatement.owner.name.toLocaleLowerCase());
      $[17] = budgetStatement.owner.name;
      $[18] = t11;
    } else {
      t11 = $[18];
    }
    const ownerNameForNavigation = t11;
    let t12;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = /\s+/g;
      $[19] = t12;
    } else {
      t12 = $[19];
    }
    const reportMonthTrimmed = reportMonth.replaceAll(t12, "");
    T3 = Link;
    t8 = `/network/powerhouse/builders/${ownerNameForNavigation}/budget-statements?viewMonth=${reportMonthTrimmed}`;
    t9 = budgetStatement.id;
    T2 = Card;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = cn("bg-background gap:0 flex w-full flex-col rounded-xl p-0 shadow-sm transition-all hover:shadow-sm", "gap-0");
      $[20] = t5;
    } else {
      t5 = $[20];
    }
    let t13;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <div className="text-foreground/30 hidden text-sm/5.5 font-semibold md:flex lg:hidden">Ecosystem Actor</div>;
      $[21] = t13;
    } else {
      t13 = $[21];
    }
    const t14 = budgetStatement.status as ExpenseReport_ExpenseReportStatus;
    let t15;
    if ($[22] !== budgetStatement.owner.code || $[23] !== budgetStatement.owner.logo || $[24] !== budgetStatement.owner.name || $[25] !== t14) {
      t15 = <div className="flex min-w-0 flex-1 flex-col">{t13}<ContributorProfileInfo name={budgetStatement.owner.name} code={budgetStatement.owner.code} isCoreUnit={true} logoUrl={budgetStatement.owner.logo} status={t14} /></div>;
      $[22] = budgetStatement.owner.code;
      $[23] = budgetStatement.owner.logo;
      $[24] = budgetStatement.owner.name;
      $[25] = t14;
      $[26] = t15;
    } else {
      t15 = $[26];
    }
    let t16;
    if ($[27] !== reportMonth) {
      t16 = <LabeledValue label="Reporting Month" value={reportMonth} className="hidden md:flex lg:hidden" />;
      $[27] = reportMonth;
      $[28] = t16;
    } else {
      t16 = $[28];
    }
    const t17 = `${usLocalizedNumber(amount)} USD`;
    let t18;
    if ($[29] !== metricLabel || $[30] !== t17) {
      t18 = <LabeledValue label={metricLabel} value={t17} className="hidden min-w-30 md:flex lg:hidden" />;
      $[29] = metricLabel;
      $[30] = t17;
      $[31] = t18;
    } else {
      t18 = $[31];
    }
    let t19;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
      t19 = <span className="text-muted-foreground/60 font-medium">Status:</span>;
      $[32] = t19;
    } else {
      t19 = $[32];
    }
    const t20 = budgetStatement.status as ExpenseReport_ExpenseReportStatus;
    let t21;
    if ($[33] !== t20) {
      t21 = <div className="hidden flex-col gap-1.5 text-sm md:flex lg:hidden">{t19}<BudgetStatementsStatus status={t20} /></div>;
      $[33] = t20;
      $[34] = t21;
    } else {
      t21 = $[34];
    }
    let t22;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
      t22 = <Button variant="outline" size="icon" className="shrink-0" aria-label="View builder team details"><ArrowRight className="size-4" /></Button>;
      $[35] = t22;
    } else {
      t22 = $[35];
    }
    if ($[36] !== t15 || $[37] !== t16 || $[38] !== t18 || $[39] !== t21) {
      t6 = <CardHeader className="flex items-start justify-between px-4 pt-4 pb-2 md:pt-2">{t15}{t16}{t18}{t21}{t22}</CardHeader>;
      $[36] = t15;
      $[37] = t16;
      $[38] = t18;
      $[39] = t21;
      $[40] = t6;
    } else {
      t6 = $[40];
    }
    if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <div className="px-4 md:hidden"><Separator className="my-2" /></div>;
      $[41] = t7;
    } else {
      t7 = $[41];
    }
    T1 = CardContent;
    t3 = "mb-2 flex items-center justify-between px-4 md:hidden";
    if ($[42] !== reportMonth) {
      t4 = <LabeledValue label="Reporting Month" value={reportMonth} />;
      $[42] = reportMonth;
      $[43] = t4;
    } else {
      t4 = $[43];
    }
    T0 = LabeledValue;
    t2 = metricLabel;
    t1 = usLocalizedNumber(amount);
    $[0] = budgetStatement;
    $[1] = selectedMetric;
    $[2] = T0;
    $[3] = T1;
    $[4] = T2;
    $[5] = T3;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    T0 = $[2];
    T1 = $[3];
    T2 = $[4];
    T3 = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
    t7 = $[12];
    t8 = $[13];
    t9 = $[14];
  }
  const t10 = `${t1} USD`;
  let t11;
  if ($[44] !== T0 || $[45] !== t10 || $[46] !== t2) {
    t11 = <T0 label={t2} value={t10} />;
    $[44] = T0;
    $[45] = t10;
    $[46] = t2;
    $[47] = t11;
  } else {
    t11 = $[47];
  }
  let t12;
  if ($[48] !== T1 || $[49] !== t11 || $[50] !== t3 || $[51] !== t4) {
    t12 = <T1 className={t3}>{t4}{t11}</T1>;
    $[48] = T1;
    $[49] = t11;
    $[50] = t3;
    $[51] = t4;
    $[52] = t12;
  } else {
    t12 = $[52];
  }
  let t13;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Separator className="-mt-1 md:mt-2" />;
    $[53] = t13;
  } else {
    t13 = $[53];
  }
  let t14;
  if ($[54] !== budgetStatement.lastModifiedAtUtcIso) {
    t14 = <CardFooter className="bg-background w-full overflow-x-hidden rounded-b-xl px-4 py-1"><LastModified lastModified={budgetStatement.lastModifiedAtUtcIso} isMobile={true} /></CardFooter>;
    $[54] = budgetStatement.lastModifiedAtUtcIso;
    $[55] = t14;
  } else {
    t14 = $[55];
  }
  let t15;
  if ($[56] !== T2 || $[57] !== t12 || $[58] !== t14 || $[59] !== t5 || $[60] !== t6 || $[61] !== t7) {
    t15 = <T2 className={t5}>{t6}{t7}{t12}{t13}{t14}</T2>;
    $[56] = T2;
    $[57] = t12;
    $[58] = t14;
    $[59] = t5;
    $[60] = t6;
    $[61] = t7;
    $[62] = t15;
  } else {
    t15 = $[62];
  }
  let t16;
  if ($[63] !== T3 || $[64] !== t15 || $[65] !== t8 || $[66] !== t9) {
    t16 = <T3 href={t8} key={t9}>{t15}</T3>;
    $[63] = T3;
    $[64] = t15;
    $[65] = t8;
    $[66] = t9;
    $[67] = t16;
  } else {
    t16 = $[67];
  }
  return t16;
}
export { BudgetStatementMobileItem };